export default __webpack_public_path__ + "static/media/tree_icon_type_lightBorder_gray.303ea3d6.svg";